<div class="viewer-container">
    <div #container class="canvas-container" style="width: 100%; position: relative;">
        @if (hoveredShot(); as shot) {
        <div class="shot-tooltip" [style.left.px]="tooltipPos().x + 12" [style.top.px]="tooltipPos().y + 12">
            <div><b>Shot {{ shot.shot_id }}</b></div>
            <div>Fit: {{ shot.traces_fit | number: '1.0-2' }}</div>
            <div>x: {{ shot.sx | number: '1.0-1' }} · y: {{ shot.sy | number: '1.0-1' }} · z: {{ shot.sz | number:
                '1.0-1' }}</div>
        </div>
        }
    </div>

    <section class="viewer-information-container">
        <div class="metrics-displayer">
            @if (xText && yText && valueText) {
            <table class="styled-table">
                <tr>
                    <td>{{ xLabel() }}</td>
                    <td>:</td>
                    <td>{{ xText }}</td>
                </tr>
                <tr>
                    <td>{{ yLabel() }}</td>
                    <td>:</td>
                    <td>{{ yText }}</td>
                </tr>
                <tr>
                    <td>Value</td>
                    <td>:</td>
                    <td>{{ valueText }}</td>
                </tr>
            </table>
            }
        </div>

        @if (colorbar()) {
        <div class="legend-container">
            <div [style.backgroundImage]="'url(' + colorbar() + ')'" class="legend-colorbar"></div>
            <span class="legend-min">{{ limits()?.min | number: '1.0-3' }}</span>
            <span class="legend-max">{{ limits()?.max | number: '1.0-3' }}</span>
            <span class="legend-type">{{ legendLabel() }}</span>
        </div>
        }
    </section>
</div>
